var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestsent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3413)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4819_3413)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8639 16.231C44.5469 15.9821 45.2868 15.9334 45.9966 16.0905C46.7063 16.2476 47.3565 16.6041 47.8707 17.118C48.3849 17.6319 48.7417 18.2819 48.8991 18.9917C49.0566 19.7014 49.0082 20.4413 48.7596 21.1244L40.3352 46.3741C40.1303 46.9946 39.7695 47.5521 39.2875 47.9933C38.8054 48.4345 38.2182 48.7446 37.5821 48.8939C36.9474 49.0483 36.2835 49.0351 35.6555 48.8558C35.0274 48.6765 34.4567 48.3371 33.9992 47.8709L29.4782 43.3711L24.7309 45.8273C24.549 45.9217 24.3455 45.9669 24.1407 45.9586C23.9359 45.9503 23.7367 45.8888 23.563 45.78C23.3892 45.6712 23.2469 45.519 23.1499 45.3384C23.053 45.1578 23.0048 44.955 23.0102 44.7501L23.2059 37.2449L39.8119 25.1834C39.9686 25.0697 40.1012 24.9262 40.2024 24.7611C40.3036 24.5961 40.3713 24.4128 40.4016 24.2216C40.4319 24.0304 40.4243 23.8351 40.3791 23.6468C40.3339 23.4586 40.2521 23.2811 40.1384 23.1245C40.0246 22.9678 39.8811 22.8351 39.7161 22.734C39.5511 22.6328 39.3677 22.5651 39.1765 22.5348C38.9853 22.5045 38.79 22.5121 38.6018 22.5573C38.4136 22.6025 38.2361 22.6842 38.0794 22.798L21.1929 35.0646L17.115 30.9867C16.6755 30.5471 16.3515 30.0057 16.1718 29.4106C15.9921 28.8156 15.9622 28.1853 16.0849 27.5759C16.2081 26.91 16.5061 26.2888 16.9485 25.776C17.3909 25.2632 17.9617 24.8773 18.6024 24.6578H18.6118L43.8639 16.231Z",
    fill: "url(#paint1_linear_4819_3413)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.003 40.1295C47.3515 40.1295 50.878 43.656 50.878 48.0045C50.878 52.3531 47.3515 55.8796 43.003 55.8796C38.6545 55.8796 35.1279 52.3531 35.1279 48.0045C35.1279 43.656 38.6545 40.1295 43.003 40.1295ZM41.3676 50.5624L39.4396 48.6328C39.1112 48.3042 39.1111 47.7682 39.4396 47.4396C39.7682 47.1111 40.3066 47.1131 40.6328 47.4396L41.992 48.7999L45.3733 45.4186C45.7019 45.09 46.2379 45.09 46.5665 45.4186C46.8951 45.7471 46.8946 46.2836 46.5665 46.6118L42.5876 50.5906C42.2595 50.9187 41.723 50.9192 41.3945 50.5906C41.3852 50.5814 41.3763 50.572 41.3676 50.5624Z",
    fill: "url(#paint2_linear_4819_3413)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3413",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3413",
    x1: 32.5003,
    y1: 16.0002,
    x2: 32.5003,
    y2: 49.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3413",
    x1: 43.003,
    y1: 40.1295,
    x2: 43.003,
    y2: 55.8796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4819_3413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestsent);
export default __webpack_public_path__ + "static/media/INTERESTSENT.c0eb4355ba9ef24adfbf487e83f43df3.svg";
export { ForwardRef as ReactComponent };